import { useCallback, useEffect, useState, } from 'react';
const defaultProps = {
    onChange: () => { },
    pageNumber: 1,
};
export const usePagination = ({ onChange = defaultProps.onChange, pageNumber = defaultProps.pageNumber, } = ({})) => {
    const [currentPageNumber, setCurrentPageNumber,] = useState(pageNumber);
    useEffect(() => {
        setCurrentPageNumber(pageNumber);
    }, [
        pageNumber,
    ]);
    const onNextClick = useCallback(() => {
        setCurrentPageNumber((currentPageNumber) => {
            const nextPageNumber = (currentPageNumber + 1);
            onChange(nextPageNumber);
            return nextPageNumber;
        });
    }, [
        onChange,
    ]);
    const onPageClick = useCallback((pageNumber) => {
        onChange(pageNumber);
        setCurrentPageNumber(pageNumber);
    }, [
        onChange,
    ]);
    const onPrevClick = useCallback(() => {
        setCurrentPageNumber((currentPageNumber) => {
            const nextPageNumber = (currentPageNumber - 1);
            onChange(nextPageNumber);
            return nextPageNumber;
        });
    }, [
        onChange,
    ]);
    const [isViewAllActive, setIsViewAllActive,] = useState(false);
    const onViewAllClick = useCallback(() => {
        setIsViewAllActive(true);
    }, []);
    const onViewLessClick = useCallback(() => {
        setIsViewAllActive(false);
    }, []);
    return {
        currentPageNumber,
        isViewAllActive,
        onNextClick,
        onPageClick,
        onPrevClick,
        onViewAllClick,
        onViewLessClick,
        setCurrentPageNumber,
    };
};
